import React, { useEffect, useRef } from "react"
import {
  Container,
  Row,
  Col, Button, Collapse
} from "reactstrap"

import Gadget from "../Gadget"

import labels from "../Workshops/const"
import useLabels from "../../utils/useLabels"

import * as s from "./style.module.css"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import Dots from "../Dots"
import { LazyLoadImage } from "react-lazy-load-image-component"

export default function WorkshopsFull(workshops, { lang }) {
  const t = useLabels(labels, lang)
  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    if (typeof location != "undefined") {
      // eslint-disable-next-line no-restricted-globals
      location.hash = location.hash
    }
  }, [])

  let showBottomGadget = true

  if (workshops.workshops && workshops.workshops.workshops.length > 0) {
    t.workshops = workshops.workshops.workshops
    t.title = workshops.workshops.title
    showBottomGadget = false
  }


  return (

    <div className={s.root}>
      <Container>
        <div className={s.header}>
          <h2>{t.title}</h2>
          <div className={s.divider} />
        </div>

      </Container>
      <ul className={s.list}>
        {t.workshops.map((workshop) => (
          <li className={s.listItem}>
            <Container>
              <div className={s.gadgetPosition2}>
                <Gadget version="green" />
              </div>

              {ShowDesc(workshop)}

              {showBottomGadget && <div className={s.gadgetPosition}>
                <Gadget version="green" />
              </div>}
            </Container>
          </li>
        ))}
      </ul>



    </div>
  )
}

export function ShowDesc(workshop) {

  const tutor = workshop
  let exsist = false
  let exsist2 = false



  let firstTutorDesc = tutor.tutorDesc
  let secondTutorDesc = ""
  let thirdTutorDesc = ""


  // Chceck if tutor exsist in Workshop

  if (tutor.secondTutor !== null && tutor.secondTutor !== undefined) {
    exsist = true
    secondTutorDesc = tutor.secondTutor.tutorDesc
  }

  if (tutor.thirdTutor !== null && tutor.thirdTutor !== undefined) {
    exsist2 = true
    thirdTutorDesc = tutor.thirdTutor.tutorDesc
  }


  let mentorsLink = "javascript:;"
  if (tutor.mentorId && tutor.mentorId.length > 0) {
    mentorsLink = "/mentors#" + encodeURIComponent(tutor.mentorId)
  }

  let logoPath = require("../Mentors/images/linkedin.svg").default

  if (workshop.id === "joga") {
    logoPath = require("../Mentors/images/fb.svg").default
    mentorsLink = "https://www.facebook.com/jogowaga"
  }


  const [showFullDesc, setShowDesc] = React.useState(false)
  const [workshopButton, changeButton] = React.useState("Zobacz więcej ⬇")

  const toggleFullDesc = () => {

    showFullDesc ? changeButton("Zobacz więcej ⬇") : changeButton("Ukryj ⬆")

    if (showFullDesc) {
      window.scrollTo({ top: myRef.current.offsetTop - 100, behavior: "smooth" });

    }

    setShowDesc(!showFullDesc)
  }

  let workshopsLink = "https://app.evenea.pl/event/hack4change2023webinaria/";


  const myRef = useRef(null)


  return (

    <div ref={myRef} id={tutor.id} className={s.workshop}>
      <h4 className={s.workshopTitle}>{tutor.workshop}</h4>
      {tutor.date && <strong className={s.date} dangerouslySetInnerHTML={{ __html: tutor.date }}/>}
      
      <div className={s.divider} />

      <Collapse isOpen={showFullDesc}>
        <p className={s.text} dangerouslySetInnerHTML={{ __html: tutor.fullDescription }} />
      </Collapse>


      <div className={s.mentors}>

        <div className="d-flex mb-3">
          {workshop.id !== "kayak" &&
            <div className={s.imageWrapper}>
              <div className={s.circle} />
              {<AnchorLink to={mentorsLink}>
                {/*<MentorImage css={s.mentorImg} filename={workshop.image} />*/}
                <LazyLoadImage effect="blur" alt="mentor zdjecie" src={workshop.image} />
              </AnchorLink>}

              <a href={workshop.linkedin} target="_blank">
                <div className={s.linkedin}>
                  <img alt="logo social mediów mentora" src={logoPath} />
                </div>
              </a>
            </div>
          }
          <div className={s.nameAndTitle}>
            <div className={s.name}>
              {workshop.name}
            </div>
            <div className={s.title}>
              {workshop.title}
            </div>
          </div>
        </div>

        <Collapse isOpen={showFullDesc}>
          <p className={s.text} dangerouslySetInnerHTML={{ __html: firstTutorDesc }} />
        </Collapse>


        {exsist &&
          <div className="d-flex my-3 md-5 w-100">
            <div className={s.imageWrapper}>

              {<AnchorLink to={mentorsLink}>
                <LazyLoadImage effect="blur" alt="mentor zdjecie" src={workshop.secondTutor.image} />
              </AnchorLink>}

              <a href={workshop.secondTutor.linkedin} target="_blank">
                <div className={s.linkedin}>
                  <img alt="logo social mediów mentora" src={logoPath} />
                </div>
              </a>
            </div>
            <div className={s.nameAndTitle}>
              <div className={s.name}>
                {workshop.secondTutor.name}
              </div>
              <div className={s.title}>
                {workshop.secondTutor.title}
              </div>
            </div>
          </div>
        }

<Collapse isOpen={showFullDesc}>
        <p className={s.text} dangerouslySetInnerHTML={{ __html: secondTutorDesc }} />
      </Collapse>

        {exsist2 &&
          <div className="d-flex mt-3 md-5 w-100">
            <div className={s.imageWrapper}>

              {<AnchorLink to={mentorsLink}>
                <LazyLoadImage effect="blur" alt="mentor zdjecie" src={workshop.thirdTutor.image} />
              </AnchorLink>}

              <a href={workshop.thirdTutor.linkedin} target="_blank">
                <div className={s.linkedin}>
                  <img alt="logo social mediów mentora" src={logoPath} />
                </div>
              </a>
            </div>
            <div className={s.nameAndTitle}>
              <div className={s.name}>
                {workshop.thirdTutor.name}
              </div>
              <div className={s.title}>
                {workshop.thirdTutor.title}
              </div>
            </div>
          </div>
        }


      </div>

      <Collapse isOpen={showFullDesc}>
        <p className={s.text} dangerouslySetInnerHTML={{ __html: thirdTutorDesc }} />
      </Collapse>



     


      <div className="d-flex flex-column flex-sm-row justify-content-center">
        <Button color="primary" className="mb-3 mb-md-0" onClick={toggleFullDesc}>{workshopButton}</Button>


        {/* <a className="text-decoration-none" href={workshopsLink}>

            <Button color="primary" className="ml-md-4 w-100">Zapisz się!</Button>

          </a> */}


      </div>

    </div>

  )

}